import axios from "@/utils/axios";
import { propOr, pathOr, path } from "ramda";
import { format } from "date-fns";
import {
  ADD_THEME_LESSONS,
  ADD_THEME_LESSONS_TOPIC,
  ADD_ASSIGNMENT_LIBRARY,
  ADD_CATEGORY_TOPICS,
  UPDATE_BUILDING_HW_ASSIGNMENT,
  RESET_HOMEWORK_ASSIGNMENT,
  SET_HW_CREATED_ASSIGNMENTS,
  SET_CURRENT_ASSIGNMENT,
  RESET_ASSIGNMENT_LIBRARY,
  ADD_BOOK_LESSONS,
} from "../constants";
import th from "@/i18n/messages/th";
const initialState = () => ({
  theme_lessons: [],
  theme_lessons_topics: [],
  book_lessons: [],
  category_topics: [],
  assignmentLibrary: {
    assigned: [],
    study_sets: [],
    lesson_sets: [],
  },
  buildingAssignment: {
    assignments: [
      {
        name: "",
        groupIds: "", //organization, group, public
        startDate: "",
        startTime: "",
        dueDate: "",
        dueTime: "",
        reminderBeforeDay: 1,
        timeNotify: "",
        maxReminderBeforeDay: 1,
      },
    ],
    lesson_original_ids: [],
    study_sets: [],
  },
  createdAssignments: [],
  currentAssignment: {},
});
const state = initialState();

const getters = {
  getThemeLessonList: pathOr([], ["theme_lessons"]),
  getThemeLessonTopicList: pathOr([], ["theme_lessons_topics"]),
  getCategoryTopicList: pathOr([], ["category_topics"]),
  getAssignmentLibraryDetail: propOr({}, ["assignmentLibrary"]),
  getBuildingAssignment: propOr({}, "buildingAssignment"),
  getCreatedAssignments: propOr([], "createdAssignments"),
  getCurrentAssignment: propOr({}, "currentAssignment"),
  getCurrentAssignmentId: path(["currentAssignment", "id"]),
  getBookLessonList: pathOr([], ["book_lessons"]),
};

const mutations = {
  [ADD_THEME_LESSONS](state, theme_lessons) {
    state.theme_lessons = theme_lessons;
  },
  [ADD_THEME_LESSONS_TOPIC](state, theme_lessons_topics) {
    state.theme_lessons_topics = theme_lessons_topics;
  },
  [ADD_BOOK_LESSONS](state, book_lessons) {
    state.book_lessons = book_lessons;
  },
  [ADD_ASSIGNMENT_LIBRARY](state, assignmentLibrary) {
    state.assignmentLibrary = assignmentLibrary;
  },
  [ADD_CATEGORY_TOPICS](state, category_topics) {
    state.category_topics = category_topics;
  },
  [RESET_ASSIGNMENT_LIBRARY](state) {
    state.assignmentLibrary = {
      assigned: [],
      study_sets: [],
      lesson_sets: [],
    };
  },
  [UPDATE_BUILDING_HW_ASSIGNMENT](state, updatedAssignment) {
    state.buildingAssignment = {
      ...state.buildingAssignment,
      ...updatedAssignment,
    };
  },
  [RESET_HOMEWORK_ASSIGNMENT](state) {
    state.buildingAssignment = {
      assignments: [
        {
          name: "",
          groupIds: "", // organization, group, public
          startDate: "",
          startTime: "",
          dueDate: "",
          dueTime: "",
          reminderBeforeDay: 1,
          timeNotify: "",
          maxReminderBeforeDay: 1,
          assign_now: false,
        },
      ],
      lesson_original_ids: [],
      study_sets: [],
      read_aloud: [],
    };
    state.theme_lessons = [];
    state.theme_lessons_topics = [];
    state.book_lessons = [];
  },
  [SET_HW_CREATED_ASSIGNMENTS](state, createdAssignments) {
    state.createdAssignments = createdAssignments;
  },
  [SET_CURRENT_ASSIGNMENT](state, assignment) {
    state.currentAssignment = assignment;
  },
};

const actions = {
  updateBuildingAssignment({ commit }, updatedAssignment) {
    commit(UPDATE_BUILDING_HW_ASSIGNMENT, updatedAssignment);
  },
  setCurrentAssignment({ commit }, currentAssignment) {
    return commit(SET_CURRENT_ASSIGNMENT, currentAssignment);
  },
  resetHomeworkAssignment({ commit }) {
    commit(RESET_HOMEWORK_ASSIGNMENT);
  },
  getThemeLessons({ commit }, params) {
    return axios.get(`/v1/homeworks/content/lessons`, { params }).then(response => {
      if (params.type === "skill") commit(ADD_THEME_LESSONS, response.data);
      else if (params.type === "topic") commit(ADD_THEME_LESSONS_TOPIC, response.data);
    });
  },
  getContentBooks({ commit }, params) {
    let organizationId = params.organization_id;
    delete params.organization_id;
    return axios.get(`/v1/homeworks/${organizationId}/content/books`, { params }).then(response => {
      commit(ADD_BOOK_LESSONS, response.data);
    });
  },
  getCategoryTopics({ commit }) {
    return axios.get(`/v1/homeworks/content/category-topic`).then(response => {
      commit(ADD_CATEGORY_TOPICS, response.data);
    });
  },
  getAssignmentLibrary({ commit, getters }, params) {
    const assignmentLibraryId = getters.getCurrentAssignmentId;
    return axios
      .get(`/v1/homeworks/${assignmentLibraryId}/assignment-library-detail`, { params })
      .then(response => commit(ADD_ASSIGNMENT_LIBRARY, response.data));
  },
  resetAssignmentLibrary({ commit }) {
    commit(RESET_ASSIGNMENT_LIBRARY);
  },
  createAssignments({ commit, getters, rootGetters }, assignment_library_id) {
    let buildingAssignments = getters["getBuildingAssignment"];
    const assignments = buildingAssignments.assignments;
    const assignedStudySets = buildingAssignments.study_sets;
    const lessonOrginalIds = buildingAssignments.lesson_original_ids;
    const readAloudIds = buildingAssignments.read_aloud;
    const aiTutorIds = buildingAssignments.ai_tutor
    const organizationId = rootGetters["organization/currentOrganizationId"];
    const payload_assignments = [];
    const now = format(Date.now(), "yyyy-MM-dd HH:mm");
    for (let i = 0; i < assignments.length; i++) {
      const assignment = assignments[i];
      const assignmentWithoutGroup = {
        name: assignment.name,
        // group: assignment.groupId,
        study_sets: assignedStudySets,
        read_aloud: readAloudIds,
        due_date: assignment.dueDate + " " + assignment.dueTime,
        start_date: assignment.startTime != "now" ? assignment.startDate + " " + assignment.startTime : now,
        reminder_before_day: assignment.reminderBeforeDay,
        notify_time: assignment.timeNotify,
        lesson_original_ids: lessonOrginalIds,
        assignment_library_id: assignment_library_id,
        assign_now: assignment.assign_now,
        ai_tutor: aiTutorIds
      };
      for (let j = 0; j < assignment.groupIds.length; j++) {
        payload_assignments.push({ ...assignmentWithoutGroup, group: assignment.groupIds[j] });
      }
    }
    const requestBody = {
      assignments: payload_assignments,
    };

    return axios.post(`/v1/study-sets/${organizationId}/assignments`, requestBody).then((response) => {
      const newAssignments = {
        ...response.data,
      }
      commit(SET_HW_CREATED_ASSIGNMENTS, newAssignments)
      commit(RESET_HOMEWORK_ASSIGNMENT)
      return response
    })
  },
  createAssignmentLibrary({ commit, getters, rootGetters }, assignment_library) {
    const organizationId = rootGetters["organization/currentOrganizationId"];
    const requestBody = { ...assignment_library };
    return axios.post(`/v1/homeworks/${organizationId}/assignment-library`, requestBody).then(response => {
      return response.data.id;
    });
  },
  deleteAssignmentLibrary({ rootGetters }, assignmentLibraryId) {
    return axios.delete(`/v1/homeworks/${assignmentLibraryId}/assignment-library-detail`);
  },
  updateAssignmentLib({ commit, rootGetters }, { assignmentLibraryId, payload } = {}) {
    return axios
      .patch(`/v1/homeworks/${assignmentLibraryId}/assignment-library-detail`, payload)
      .then(response => commit(ADD_ASSIGNMENT_LIBRARY, response.data));
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
